// Cart Interceptor for Non-Plus Stores
// Handles cart interception and configuration ID generation

(function() {
  document.addEventListener('DOMContentLoaded', () => {
    // Configuration constants - will be set by liquid template
    let ADDON_ID, PRICE_PER_MM, SINGLE_TAP, DOUBLE_TAP, HOLE_8MM, HOLE_10MM, BASE_PRICE;
    const BASE_LENGTH_MM = 1000;
    
    // Initialize interceptor with pricing constants
    window.initCartInterceptor = function(config) {
      console.log('🔧 CART INTERCEPTOR INITIALIZING...', config);
      
      ADDON_ID = config.addonId;
      PRICE_PER_MM = config.pricePerMm;
      SINGLE_TAP = config.singleTap;
      DOUBLE_TAP = config.doubleTap;
      HOLE_8MM = config.hole8mm;
      HOLE_10MM = config.hole10mm;
      BASE_PRICE = config.basePrice;
      
      console.log('✅ CART INTERCEPTOR READY');
      setTimeout(interceptAddToCart, 500);
    };
    
    // Cart interception for non-Plus stores
    function interceptAddToCart() {
      // Only target actual add-to-cart buttons, NOT checkout buttons
      const buttons = document.querySelectorAll('[name="add"], .btn--add-to-cart, form[action*="/cart/add"] button[type="submit"]:not([name="checkout"])');
      
      buttons.forEach(button => {
        if (button.dataset.intercepted) return;
        
        // Skip cart drawer/mini-cart buttons - let them work normally
        if (button.closest('.mini-cart, .cart-drawer, cart-drawer-recommendations, .drawer')) {
          console.log('⏭️ Skipping cart drawer button - not intercepting');
          return;
        }
        
        button.dataset.intercepted = 'true';
        
        button.addEventListener('click', function(e) {
          console.log('🔥🔥🔥 NEW CART INTERCEPTOR CLICKED 🔥🔥🔥');
          e.preventDefault();
          e.stopPropagation();
          
          // Ensure we stop any other handlers
          e.stopImmediatePropagation();
          
          // CAPTURE ALL VALUES AT THE START INCLUDING QUANTITY!
          const form = this.closest('form');
          
          // CRITICAL: Read quantity fresh from the DOM
          const quantitySelectors = [
            '.quantity-selector__input',
            'input[name="quantity"]',
            '#Quantity',
            '[data-quantity-input]'
          ];
          
          let quantityInput = null;
          for (const selector of quantitySelectors) {
            quantityInput = form.querySelector(selector);
            if (quantityInput) break;
          }
          
          // If still not found, try looking in the document with form attribute
          if (!quantityInput && form.id) {
            quantityInput = document.querySelector(`input[form="${form.id}"][name="quantity"]`);
          }
          
          // CRITICAL FIX: Get fresh value from input, force read from DOM
          // Use getAttribute to bypass any cached values
          let capturedQuantity = 1;
          if (quantityInput) {
            // Try multiple ways to get the value to ensure freshness
            const attrValue = quantityInput.getAttribute('value');
            const propValue = quantityInput.value;
            const dataValue = quantityInput.dataset.quantity;
            
            console.log('  Value methods - attr:', attrValue, 'prop:', propValue, 'data:', dataValue);
            
            // Use property value as it's most current
            capturedQuantity = parseInt(propValue, 10) || parseInt(attrValue, 10) || 1;
          }
          
          console.log('🎯 CAPTURED QUANTITY AT CLICK:', capturedQuantity);
          console.log('  Quantity input element:', quantityInput);
          console.log('  Quantity input name:', quantityInput?.name);
          console.log('  Quantity input form:', quantityInput?.form?.id);
          console.log('  Quantity value (raw):', quantityInput?.value);
          console.log('  Quantity value (parsed):', capturedQuantity);
          
          const variantIdInput = form.querySelector('input[name="id"]');
          const variantId = variantIdInput ? variantIdInput.value : '';

          const lengthInput = document.getElementById('extrusion-length');
          const tappingInput = document.getElementById('tapping-prop');
          const holesInput = document.getElementById('holes-prop');

          // Store values immediately to prevent them from changing
          const capturedValues = {
            lengthMm: Number(lengthInput?.value || 1000),
            tappingValue: tappingInput?.value || '',
            holesValue: holesInput?.value || '',
            quantity: parseInt(capturedQuantity, 10) || 1  // ENSURE IT'S A NUMBER!
          };

          // Generate a unique, product-scoped configuration ID
          const randomId = window.AMECartConfig
            ? window.AMECartConfig.generateConfigId(variantId, capturedValues.lengthMm, capturedValues.tappingValue, capturedValues.holesValue)
            : ('V' + variantId + '-Q' + capturedValues.quantity + '-T' + Date.now() + '-R' + Math.floor(Math.random() * 10000));
          capturedValues.configId = randomId;
          console.log('🆔 USING CONFIG ID (with variant):', randomId);

          const productTitle = document.querySelector('.product__title, h1')?.textContent?.trim() || 'Aluminum Profile';
          
          console.log('🚀 CAPTURED VALUES AT CLICK TIME:');
          console.log('Form ID:', form.id);
          console.log('Variant ID:', variantId);
          console.log('Quantity:', capturedValues.quantity, '(type:', typeof capturedValues.quantity, ')');
          console.log('Length:', capturedValues.lengthMm);
          console.log('Tapping:', capturedValues.tappingValue);
          console.log('Holes:', capturedValues.holesValue);
          console.log('Config ID:', capturedValues.configId);
          
          const extraLength = Math.max(capturedValues.lengthMm - BASE_LENGTH_MM, 0);
          const extraLengthCost = extraLength * PRICE_PER_MM;
          
          // Tapping logic - single vs double detection
          let tappingCost = 0;
          if (capturedValues.tappingValue === 'tap left end M8' || capturedValues.tappingValue === 'tap right end M8' || capturedValues.tappingValue === 'tap one end M8') {
            tappingCost = Number(SINGLE_TAP) || 0;
          } else if (capturedValues.tappingValue === 'tap both ends M8') {
            tappingCost = Number(DOUBLE_TAP) || 0;
          }
          
          let holesCost = 0;
          if (capturedValues.holesValue && capturedValues.holesValue.trim()) {
            const hole8Count = (capturedValues.holesValue.match(/8mm/g) || []).length;
            const hole10Count = (capturedValues.holesValue.match(/10mm/g) || []).length;
            holesCost = (hole8Count * Number(HOLE_8MM)) + (hole10Count * Number(HOLE_10MM));
          }
          
          const totalExtraCost = Number(extraLengthCost) + Number(tappingCost) + Number(holesCost);
          const feeUnits = Math.round(totalExtraCost * 100);
          
          console.log('=== FINAL COSTS ===');
          console.log('Extra Length:', extraLengthCost);
          console.log('Tapping:', tappingCost);
          console.log('Holes:', holesCost);
          console.log('Total Extra:', totalExtraCost);
          console.log('Fee Units:', feeUnits);
          
          // Create NEW FormData from scratch with only what we need
          const formData = new FormData();
          
          // REMOVE - Don't get quantity again, use captured value
          // const quantityInput = form.querySelector('.quantity-selector__input, input[name="quantity"]');
          // const quantity = quantityInput ? quantityInput.value : '1';
          
          console.log('📦 USING CAPTURED QUANTITY:', capturedValues.quantity);
          console.log('  Type of quantity:', typeof capturedValues.quantity);
          console.log('  Variant ID:', variantId);
          console.log('  Product:', productTitle);
          
          if (!variantId) {
            console.error('No variant ID found!');
            form.submit();
            return;
          }
          
          // Add only the essential fields - USE CAPTURED QUANTITY!
          formData.append('id', variantId);
          formData.append('quantity', String(capturedValues.quantity)); // Convert to string for FormData
          
          // Add our properties with the random Configuration ID
          formData.append('properties[Length (mm)]', String(capturedValues.lengthMm));
          formData.append('properties[Tapping]', capturedValues.tappingValue || '');
          formData.append('properties[Configuration ID]', capturedValues.configId);
          // Add timestamp to ensure uniqueness
          formData.append('properties[Added At]', new Date().toISOString());
          
          // Add holes property if it exists
          if (capturedValues.holesValue && capturedValues.holesValue.trim()) {
            formData.append('properties[Holes]', capturedValues.holesValue);
          }
          
          // Debug: Check what's being sent for base product
          console.log('=== BASE PRODUCT FORM DATA (CLEAN WITH RANDOM ID) ===');
          for (let [key, value] of formData.entries()) {
            console.log(key + ':', value);
          }
          
          // FLIPPED ORDER: Add customization product FIRST if needed
          const addCustomizationFirst = feeUnits > 0 ? 
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: ADDON_ID,
                  quantity: feeUnits * capturedValues.quantity,
                  properties: {
                    'Configuration ID': capturedValues.configId,
                    'For': productTitle,
                    'Length': capturedValues.lengthMm + 'mm',
                    'Tapping': capturedValues.tappingValue || 'None',
                    'Holes': capturedValues.holesValue || 'None',
                    'Extra Cost': '$' + Number(totalExtraCost).toFixed(2),
                    'Base Quantity': String(capturedValues.quantity),
                    'Unit Fee': String(feeUnits)
                  }
                }]
              })
            })
            .then(response => {
              console.log('=== CUSTOMIZATION PRODUCT RESPONSE ===');
              console.log('Status:', response.status);
              return response.json();
            })
            .then(data => {
              console.log('=== CUSTOMIZATION PRODUCT ADDED ===');
              console.log('Should have Config ID:', capturedValues.configId);
              console.log('Response data:', data);
              return data;
            })
            : Promise.resolve();
          
          // After customization product (if any), add the base product
          addCustomizationFirst
          .then(() => {
            console.log('=== NOW ADDING BASE PRODUCT ===');
            console.log('Config ID being sent:', capturedValues.configId);
            
            return fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });
          })
          .then(response => response.json())
          .then(data => {
            console.log('=== BASE PRODUCT ADDED ===');
            console.log('Should have Config ID:', capturedValues.configId);
            console.log('Response data:', data);
            console.log('✅ Both products added to cart with Config ID:', capturedValues.configId);
            
            // DIRECT REDIRECT TO CART PAGE - NO DRAWER, NO RELOAD
            window.location.href = '/cart';
          })
          .catch(error => {
            console.error('Error:', error);
            form.submit();
          });
        });
      });
    }
  });
})();